module.exports = __webpack_public_path__ + "static/track-2-1ea8db8a7ea775b92b43220fdd22fcbf.jpg";